import { isEmpty, values, filter } from 'lodash';

export function getLearningResult(state, getters) {
  if (!isEmpty(state.learningResults[getters.getCardId]) &&
      state.learningResults[getters.getCardId].assignment_id) {
    return state.learningResults[getters.getCardId];
  }

  if (isEmpty(getters.getCard)
    || isEmpty(getters.getCard.submissions)
    || !getters.getCard.submissions.length) {
    return {};
  }

  const submissions = getters.getCard.submissions;

  return submissions.filter(submission => submission.student_id === getters.currentUserId)[0] || {};
}

export function isAssignmentSubmitted(state, getters) {
  return getters.getLearningResult.is_submitted;
}

export function getClassRanks(state, getters) {
  if (!getters.getCardId || isEmpty(state.learningResults)) {
    return {};
  }

  return (state.learningResults[getters.getCardId] || {}).class_ranks;
}

export function getAllRanks(state, getters) {
  if (!getters.getCardId || isEmpty(state.learningResults)) {
    return {};
  }

  return (state.learningResults[getters.getCardId] || {}).all_ranks;
}

export function isForceResult(state) {
  return state.isForceResult;
}

export function getEssayQuizzes(state, getters) {
  const essayTypeName = 'essay_type';

  return filter(values(getters.getPageList), item => (
    item.page_type.name === essayTypeName
  ));
}

export function getAssignmentStats(state) {
  return state.assignmentStats || {};
}
